var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-col align-self-center mx-auto"},[_c('v-card',[_c('v-card-text',[_vm._v(" Your account has been suspended. "),_c('br'),_vm._v(" Please contact our support if you think this was a mistake. ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }